import { IInternalList } from '@brighterion/types/config';

/** Used by Axios interceptors and CubeJS Api */
export const AUTH_ACCESS_TOKEN = 'spring-auth-access-token';
export const AUTH_REFRESH_TOKEN = 'spring-auth-refresh-token';

/** Rule Set ID and Pipeline ID Keys are used for Axios Params */
export const PIPELINE_ID_SESSION_KEY = 'pipelineId';

/** Secret Key used for encrept and decrept of app-storage(sessionStorage) of zustand */
export const SECRET_KEY = 'app-storage-secret';

// we can't use the \w regex because it includes underscore
// (which is not what we want)
export const ALPHANUMERIC_REGEX = /^[\da-z]*$/i;
export const SPACE_ALPHANUMERIC_REGEX = /^[\d\sa-z]+$/i;

// Access messages
export const APPLICATION_ACCESS_PENDING = 'Application access pending';
export const PLEASE_CONSULT_ADMIN = 'Please consult your administrator about access.';

// specify a regex that allows all characters
// with a min and a max - case insensitive
function minMaxAnyCharacterRegex(min: number, max: number) {
    return new RegExp(`^.{${min},${max}}$`, 'i');
}

export const ONE_TO_150_ANY = minMaxAnyCharacterRegex(1, 150);

// alert banner timings
export const ALERT_BANNER_DURATION_DEFAULT = 3000;

export const SCREEN_ENTITIES_LIST = [
    { id: '1', screenEntity: 'Sender Name' },
    { id: '2', screenEntity: 'Sender Bank' },
    { id: '3', screenEntity: 'Recipient Name' },
    { id: '4', screenEntity: 'Recipient Bank' }
];

export const INTERNAL_LIST: IInternalList[] = [
    {
        id: '1',
        name: 'Allowed Persons'
    },
    {
        id: '2',
        name: 'Allowed Countries'
    },
    {
        id: '3',
        name: 'Denied Countries'
    },
    {
        id: '4',
        name: 'Entity Noise Words'
    },
    {
        id: '5',
        name: 'Address Noisy Words'
    },
    {
        id: '6',
        name: 'Denied Persons'
    }
];
export const EXTERNAL_LIST = [
    {
        id: 'A3EE5E30-30E9-44FF-A804-653923347026',
        name: 'LN_SANCTION_AU_DFAT',
        description: 'Department of Foreign Affairs and Trade [LN_SANCTION_AU_DFAT]',
        country: 'Australia',
        active: true,
        official: true
    },
    {
        id: '3449E2C5-6DD9-4A04-9248-7DA533F8E5B2',
        name: 'LN_SANCTION_AU_CWLAW',
        description: 'Commonwealth Law [LN_SANCTION_AU_CWLAW]',
        country: 'Australia',
        active: true,
        official: true
    }
];

export const API_URLS = {
    baseURL: '/wls-config/list',
    getConfiguration: '/wls-config/config',
    getScreenEntities: '/wls-config/entities',
    pendingChangesUpdateStatus: '/wls-config/config/updateStatus',
    getPendingChanges: '/wls-config/configs/pending',
    getRevisionHistory: '/wls-config/configs/revisionHistory',
    getExternalList: '/wls-config/lists/externalLists',
    postConfiguration: '/wls-config/config',
    getAllowedCountries: (listId: number | string) => `wls-config/list/countries-list/allowed/${listId}`,
    getDeniedCountries: (listId: number | string) => `wls-config/list/countries-list/denied/${listId}`,
    getNameNoisewords: '/wls-config/list/v1/noisewords/name',
    getAddressNoisewords: '/wls-config/list/v1/noisewords/address',
    getAllowedEntityPendingChanges: (listId: string) => `/wls-config/list/entities/allowed/${listId}/pendingChanges`,

    getDeniedEntityPendingChanges: (listId: string) => `/wls-config/list/entities/denied/${listId}/pendingChanges`,
    getAllowedEntityReviewChanges: (listId: string) => `/wls-config/list/entities/allowed/${listId}/reviewChanges`,
    getDeniedEntityReviewChanges: (listId: string) => `/wls-config/list/entities/denied/${listId}/reviewChanges`,
    getAllowedEntityReviewChangesApproveReject: '/wls-config/list/entities/allowed/approve',
    getDeniedEntityReviewChangesApproveReject: '/wls-config/list/entities/denied/approve',
    getAllowedEntities: (listId: number | string) => `wls-config/list/entities-list/allowed/${listId}`,
    getDeniedEntities: (listId: number | string) => `wls-config/list/entities-list/denied/${listId}`,
    getAllowedOrganizations: (listId: number | string) => `wls-config/list/organizations-list/allowed/${listId}`,
    getDeniedOrganizations: (listId: number | string) => `wls-config/list/organizations-list/denied/${listId}`,
    getAllowedOrganizationPendingChanges: (listId: string) =>
        `/wls-config/list/organizations/allowed/${listId}/pendingChanges`,
    getDeniedOrganizationPendingChanges: (listId: string) =>
        `/wls-config/list/organizations/denied/${listId}/pendingChanges`,
    getAllowedOrganizationReviewChanges: (listId: string) =>
        `/wls-config/list/organizations/allowed/${listId}/reviewChanges`,
    getDeniedOrganizationReviewChanges: (listId: string) =>
        `/wls-config/list/organizations/denied/${listId}/reviewChanges`,
    getAllowedOrganizationReviewChangesApproveReject: '/wls-config/list/organizations/allowed/approve',
    getDeniedOrganizationReviewChangesApproveReject: '/wls-config/list/organizations/denied/approve',
    getAllowedOrganizationRevisionHistory: (listId: string) =>
        `/wls-config/list/organizations/allowed/${listId}/revisionHistory`,
    getDeniedOrganizationRevisionHistory: (listId: string) =>
        `/wls-config/list/organizations/denied/${listId}/revisionHistory`,
    getAllowedEntityRevisionHistory: (listId: string) => `/wls-config/list/entities/allowed/${listId}/revisionHistory`,
    getDeniedEntityRevisionHistory: (listId: string) => `/wls-config/list/entities/denied/${listId}/revisionHistory`,
    getList: '/wls-config/lists/userList',
    deleteAllowedEntitiesIndividualPendingChange: '/wls-config/list/entities/allowed/pendingChanges',
    deleteDeniedEntitiesIndividualPendingChange: '/wls-config/list/entities/denied/pendingChanges',
    deleteAllowedOrganizationIndividualPendingChange: '/wls-config/list/organizations/allowed/pendingChanges',
    deleteDeniedOrganizationIndividualPendingChange: '/wls-config/list/organizations/denied/pendingChanges',
    deleteAllowedCountryIndividualPendingChange: '/wls-config/list/countries/allowed/pendingChanges',
    deleteDeniedCountryIndividualPendingChange: '/wls-config/list/countries/denied/pendingChanges',
    postAdhocSearch: '/screening-api/adhocScreenTransaction',
    postAllowedEntity: 'wls-config/list/entities/allowed',
    postDeniedEntity: 'wls-config/list/entities/denied',
    postAllowedOrganization: 'wls-config/list/organizations/allowed',
    postDeniedOrganization: 'wls-config/list/organizations/denied',
    postAllowedCountry: 'wls-config/list/countries/allowed',
    postDeniedCountry: 'wls-config/list/countries/denied',
    postNameNoiseWords: 'wls-config/list/noisewords/name',
    postAddressNoiseWords: 'wls-config/list/noisewords/address',
    getAllowedEntityRevHistById: (revId: number) =>
        `/wls-config/list/entities/allowed/${revId}/detailedRevisionHistory`,
    getDeniedEntityRevHistById: (revId: number) => `/wls-config/list/entities/denied/${revId}/detailedRevisionHistory`,
    getAllowedOrganizationRevHistById: (revId: number) =>
        `/wls-config/list/organizations/allowed/${revId}/detailedRevisionHistory`,
    getDeniedOrganizationRevHistById: (revId: number) =>
        `/wls-config/list/organizations/denied/${revId}/detailedRevisionHistory`,
    cancelOrDiscardRequest: (list: string, subList: string, actionType: string, currentRevisionId: number = 1) =>
        `${API_URLS.baseURL}/${list}/${subList}/updateStatus/${actionType}/revision/${currentRevisionId}`,
    getAllowedCountriesPendingChanges: (listId: string) =>
        `/wls-config/list/countries/allowed/${listId}/pendingChanges`,
    getDeniedCountriesPendingChanges: (listId: string) => `/wls-config/list/countries/denied/${listId}/pendingChanges`,
    getNameNoisewordsPendingChanges: (listId: string) => `/wls-config/list/noisewords/name/${listId}/pendingChanges`,
    getAddressNoisewordsPendingChanges: (listId: string) =>
        `/wls-config/list/noisewords/address/${listId}/pendingChanges`,
    getAllowedCountryRevHistById: (revId: number) =>
        `/wls-config/list/countries/allowed/${revId}/detailedRevisionHistory`,
    getDeniedCountryRevHistById: (revId: number) =>
        `/wls-config/list/countries/denied/${revId}/detailedRevisionHistory`,
    getAllowedCountriesReviewChanges: (listId: string) => `/wls-config/list/countries/allowed/${listId}/reviewChanges`,
    getDeniedCountriesReviewChanges: (listId: string) => `/wls-config/list/countries/denied/${listId}/reviewChanges`,
    getNameNoisewordsReviewChanges: (listId: string) => `/wls-config/list/noisewords/name/${listId}/reviewChanges`,
    getAddressNoisewordsReviewChanges: (listId: string) =>
        `/wls-config/list/noisewords/address/${listId}/reviewChanges`,
    getAllowedCountriesRevisionHistory: (listId: string) =>
        `/wls-config/list/countries/allowed/${listId}/revisionHistory`,
    getDeniedCountriesRevisionHistory: (listId: string) =>
        `/wls-config/list/countries/denied/${listId}/revisionHistory`,
    getNameNoisewordsRevisionHistory: (listId: string) => `/wls-config/list/noisewords/name/${listId}/revisionHistory`,
    getAddressNoisewordsRevisionHistory: (listId: string) =>
        `/wls-config/list/noisewords/address/${listId}/revisionHistory`,
    getNameNoisewordsRevHistById: (revId: number) =>
        `/wls-config/list/noisewords/name/${revId}/detailedRevisionHistory`,
    getAddressNoisewordsRevHistById: (revId: number) =>
        `/wls-config/list/noisewords/address/${revId}/detailedRevisionHistory`,
    downloadListCsvFile: (listName: string) => `/wls-config/list/${listName}/download`,
    postFileUpload: (listId: string) => `/wls-config/upload/list/${listId}`,
    putFileDelete: (uploadId: string) => `/wls-config/upload/cancel/metadata/${uploadId}`,
    postFileImport: (uploadId: string, listId: string) => `wls-config/import/metadata/${uploadId}/list/${listId}`,
    getImportStatus: () => 'wls-config/import/metadata',
    getBatchScreeningList: () => '/screening-api/batch/batchScreenedFileDetails',
    postBatchUpload: '/screening-api/batch/upload',
    postChunkUpload: '/screening-api/batch/upload/part',
    downloadBatchScreeningFile: () => '/screening-api/batch/download',
    postBatchStatus: '/screening-api/batch/status',
    cancelFileUpload: '/screening-api/batch/upload/cancel',
    removeFileUpload: '/screening-api/batch/upload/remove',
    postbatchScreening: (batchId: number) => `/screening-api/batch/screen-transactions/${batchId}`,
    getConfigStatusPolling: 'wls-config/configuration/status',
    getInternListStatusPolling: 'wls-config/lists/status',
    getScreenEntity: '/wls-config/screenEntity/allScreenEntities',
    getUploadRequestsCount: '/screening-api/batch/totalProcessingRecords',
    getMaxUploadRequests: '/wls-config/config/getNumberOfFiles',
    getTenantsList: () => '/wls-config/tenants'
};

const oneMB = 1_048_576;
export const FILE_SIZES = Object.freeze({
    '1 MB': oneMB,
    '2 MB': oneMB * 2,
    '10 MB': oneMB * 10,
    '100 MB': oneMB * 10 * 10,
    '1 GB': 1_073_741_824
});

export const FILE_UPLOAD_MAX_CHUNK_SIZE = 100;

export const ALLOWED_COUNTRIES = 'getAllowedCountries';
export const DENIED_COUNTRIES = 'getDeniedCountries';
export const NAME_NOISEWORDS = 'getNameNoisewords';
export const ADDRESS_NOISEWORDS = 'getAddressNoisewords';
export const ALLOWED_ENTITY_PENDING_CHANGES = 'allowedEntitiesPendingChanges';
export const DENIED_ENTITY_PENDING_CHANGES = 'deniedEntitiesPendingChanges';
export const ALLOWED_ENTITY_REVIEW_CHANGES = 'allowedEntitiesReviewChanges';
export const DENIED_ENTITY_REVIEW_CHANGES = 'deniedEntitiesReviewChanges';
export const GET_ALLOWED_ENTITIES = 'getAllowedEntities';
export const GET_DENIED_ENTITIES = 'getDeniedEntities';
export const GET_ALLOWED_ORGANIZATIONS = 'getAllowedOrganizations';
export const GET_DENIED_ORGANIZATIONS = 'getDeniedOrganizations';
export const ALLOWED_ENTITY_REVISION_HISTORY = 'allowedEntitiesRevisionHistory';
export const DENIED_ENTITY_REVISION_HISTORY = 'deniedEntitiesRevisionHistory';
export const ALLOWED_ORGANIZATION_PENDING_CHANGES = 'allowedOrganizationsPendingChanges';
export const DENIED_ORGANIZATION_PENDING_CHANGES = 'deniedOrganizationsPendingChanges';
export const ALLOWED_ORGANIZATION_REVIEW_CHANGES = 'allowedOrganizationsReviewChanges';
export const DENIED_ORGANIZATION_REVIEW_CHANGES = 'deniedOrganizationsReviewChanges';
export const ALLOWED_ORGANIZATION_REVISION_HISTORY = 'allowedOrganizationsRevisionHistory';
export const DENIED_ORGANIZATION_REVISION_HISTORY = 'deniedOrganizationsRevisionHistory';
export const ALLOWED_ENTITY_PENDING_CHANGES_ITEM_DELETE = 'allowedEntitiesPendingChangesIndividualDelete';
export const DENIED_ENTITY_PENDING_CHANGES_ITEM_DELETE = 'deniedEntitiesPendingChangesIndividualDelete';
export const ALLOWED_COUNTRY_PENDING_CHANGES_ITEM_DELETE = 'allowedCountriesPendingChangesIndividualDelete';
export const DENIED_COUNTRY_PENDING_CHANGES_ITEM_DELETE = 'deniedCountryPendingChangesIndividualDelete';
export const ALLOWED_ENTITY_REVISION_HISTORY_DETAILS = 'allowedEntitiesRevHistDetails';
export const DENIED_ENTITY_REVISION_HISTORY_DETAILS = 'deniedEntitiesRevHistDetails';
export const ALLOWED_ENTITY_CANCEL_APPROVAL_REQUEST = 'allowedEntityCancelApprovalRequest';
export const DENIED_ENTITY_CANCEL_APPROVAL_REQUEST = 'deniedEntityCancelApprovalRequest';
export const ALLOWED_ORGANIZATION_REVISION_HISTORY_DETAILS = 'allowedOrganizationsRevHistDetails';
export const DENIED_ORGANIZATION_REVISION_HISTORY_DETAILS = 'deniedOrganizationsRevHistDetails';
export const ALLOWED_ORGANIZATION_CANCEL_APPROVAL_REQUEST = 'allowedOrganizationCancelApprovalRequest';
export const DENIED_ORGANIZATION_CANCEL_APPROVAL_REQUEST = 'deniedOrganizationCancelApprovalRequest';
export const ALLOWED_ORGANIZATION_PENDING_CHANGES_ITEM_DELETE = 'allowedOrganizationsPendingChangesIndividualDelete';
export const DENIED_ORGANIZATION_PENDING_CHANGES_ITEM_DELETE = 'deniedOrganizationsPendingChangesIndividualDelete';
export const ALLOWED_COUNTRY_PENDING_CHANGES = 'allowedCountriesPendingChanges';
export const DENIED_COUNTRY_PENDING_CHANGES = 'deniedCountriesPendingChanges';
export const NAME_NOISEWORDS_PENDING_CHANGES = 'nameNoisewordsPendingChanges';
export const ADDRESS_NOISEWORDS_PENDING_CHANGES = 'addressNoisewordsPendingChanges';
export const ALLOWED_COUNTRY_REVISION_HISTORY_DETAILS = 'allowedCountryRevHistDetails';
export const DENIED_COUNTRY_REVISION_HISTORY_DETAILS = 'deniedCountryRevHistDetails';
export const ALLOWED_COUNTRY_REVIEW_CHANGES = 'allowedCountriesReviewChanges';
export const DENIED_COUNTRY_REVIEW_CHANGES = 'deniedCountriesReviewChanges';
export const NAME_NOISEWORDS_REVIEW_CHANGES = 'nameNoisewordsReviewChanges';
export const ADDRESS_NOISEWORDS_REVIEW_CHANGES = 'addressNoisewordsReviewChanges';
export const ALLOWED_COUNTRY_REVISION_HISTORY = 'allowedCountriesRevisionHistory';
export const DENIED_COUNTRY_REVISION_HISTORY = 'deniedCountriesRevisionHistory';
export const NAME_NOISEWORDS_REVISION_HISTORY = 'nameNoisewordsRevisionHistory';
export const ADDRESS_NOISEWORDS_REVISION_HISTORY = 'addressNoisewordsRevisionHistory';
export const NAME_NOISEWORDS_REVISION_HISTORY_DETAILS = 'nameNoisewordsRevHistDetails';
export const ADDRESS_NOISEWORDS_REVISION_HISTORY_DETAILS = 'addressNoisewordsRevHistDetails';
export const SCREEN_ENTITIES = 'getScreenEntity';

export const DEFAULT_PAGINATION = {
    pageIndex: 0,
    pageSize: 10
};

export const ALLOWED_ENTITIES = 'Allowed Persons';
export const DENIED_ENTITIES = 'Denied Persons';
export const DENIED_ENTITIES_ALIAS_NAME = 'Denied Entities';

// Map URL-derived names to display names
export const DISPLAY_NAME_MAP: Record<string, string> = {
    'Allowed Entities': 'Allowed Persons',
    'Denied Entities': 'Denied Persons',
    'Name Noisewords': 'Noise Words',
    'Address Noisewords': 'Address Noise Words'
};
export const ALLOWED_ORGANIZATIONS = 'Allowed Organizations';
export const DENIED_ORGANIZATIONS = 'Denied Organizations';
export const ALLOWED_COUNTRIES_TITLE = 'Allowed Countries';
export const DENIED_COUNTRIES_TITLE = 'Denied Countries';
export const NAME_NOISE_WORDS_TITLE = 'Noise Words';
export const ADDRESS_NOISE_WORDS_TITLE = 'Address Noise Words';

export const COUNRTY_NOISE_TITLES = {
    ALLOWED_COUNTRIES_TITLE,
    DENIED_COUNTRIES_TITLE,
    NAME_NOISE_WORDS_TITLE,
    ADDRESS_NOISE_WORDS_TITLE
};

export const MAPPED_IDS = new Map([
    ['Allowed Countries', 'allowed-countries'],
    ['Allowed Entities', 'allowed-entities'],
    ['Allowed Persons', 'allowed-entities'],
    ['Allowed Organizations', 'allowed-organizations'],
    ['Denied Countries', 'denied-countries'],
    ['Denied Entities', 'denied-entities'],
    ['Denied Persons', 'denied-entities'],
    ['Denied Organizations', 'denied-organizations'],
    ['Entity Noise Words', 'name-noisewords'],
    ['Address Noise Words', 'address-noisewords']
]);
export const adHocSearchPersonHeading = 'Either Last name, Street Address or Country is required to start a search.';
export const adHocSearchOrgHeading =
    'Either Organization Name, Street Address or Country is required to start a search.';

export const ENTRY_STATUS = {
    NEW: 'new',
    MODIFIED: 'modified',
    REMOVED: 'removed',
    VIEWED: 'viewed'
};

export const MESSAGE_MAP = {
    new: {
        success: '1 entry has been added to {listType}.',
        error: 'Something went wrong, while adding the entry.'
    },
    modified: {
        success: 'The list entry has been successfully updated.',
        error: 'Something went wrong, while updating the entry.'
    },
    removed: {
        success: '1 entry has been removed from {listType}.',
        error: 'Something went wrong, while removing the entry.'
    },
    viewed: {
        success: '',
        error: ''
    }
};
export const MIXPANEL_IDENTIFIERS = {
    editConfiguration: {
        clickIdentifier: 'WLS Configuration - Edit Configuration',
        text: 'Edit Configuration'
    },
    viewList: {
        clickIdentifier: 'Lists - View List',
        text: 'View List'
    },
    viewTenant: {
        clickIdentifier: 'Tenants - View Tenant',
        text: 'View Tenant'
    },
    addListEntry: {
        clickIdentifier: 'Lists - Add List Entry',
        text: 'Add List Entry'
    },
    searchList: {
        clickIdentifier: 'Lists - Search List',
        text: 'Search List'
    },
    bulkUploadEntries: {
        clickIdentifier: 'Lists - Bulk Upload Entries',
        text: 'Bulk Upload Entries (Requester)'
    },
    startBulkUpload: {
        clickIdentifier: 'Lists - Start Bulk Upload',
        text: 'Start Bulk Upload (Requester)'
    },
    deleteListEntry: {
        clickIdentifier: 'Lists - Delete List Entry',
        text: 'Delete List Entry (Requester)'
    },
    editListEntry: {
        clickIdentifier: 'Lists - Edit List Entry',
        text: 'Edit List Entry (Requester)'
    },
    viewListEntry: {
        clickIdentifier: 'Lists - View List Entry',
        text: 'View List Entry (Requester)'
    },
    pendingChanges: {
        clickIdentifier: 'Lists - Pending Changes',
        text: 'Pending Changes (Requester)'
    },
    sendForApproval: {
        clickIdentifier: 'Lists - Send for Approval',
        text: 'Send for Approval (Requester)'
    },
    discardAllChanges: {
        clickIdentifier: 'Lists - Discard Changes',
        text: 'Discard All Changes (Requester)'
    },
    cancelApprovalRequest: {
        clickIdentifier: 'Lists - Cancel Approval Request',
        text: 'Cancel Approval Request (Requester)'
    },
    reviewChanges: {
        clickIdentifier: 'Lists - Review Changes',
        text: 'Pending Changes (Approver)'
    },
    approve: {
        clickIdentifier: 'Lists - Approve Changes',
        text: 'Approve Changes (Approver)'
    },
    reject: {
        clickIdentifier: 'Lists - Reject Changes',
        text: 'Reject Changes (Approver)'
    },
    cancelApproval: {
        clickIdentifier: 'Lists - Cancel Approval',
        text: 'Cancel Approval (Approver)'
    },
    unlockList: {
        clickIdentifier: 'Lists - Unlock List',
        text: 'Unlock List (Other user)'
    },
    adhocPersonSearch: {
        clickIdentifier: 'Adhoc Screening - Search',
        text: 'Person Search'
    },
    adhocOrganizationSearch: {
        clickIdentifier: 'Adhoc Screening - Search',
        text: 'Organization Search'
    },
    startPersonScreening: {
        clickIdentifier: 'Batch Screening - Screening',
        text: 'Person Screening'
    },
    startOrganizationScreening: {
        clickIdentifier: 'Batch Screening - Screening',
        text: 'Organization Screening'
    },
    startDownload: {
        clickIdentifier: 'Batch Screening - Download',
        text: 'File Download'
    },
    adhocDownload: {
        clickIdentifier: 'Adhoc Screening - Export Matches',
        text: 'Export Matches'
    },
    listDownload: {
        clickIdentifier: 'Lists - Export Entries',
        text: 'Export List Entries'
    }
};

export const screeningScoreAttributes: Record<string, string> = {
    aliases: 'Aliases:',
    city: 'City:',
    country: 'Country:',
    dateOfBirth: 'Date of Birth:',
    gender: 'Gender:',
    // height: 'Height:',
    name: 'Name:',
    nationality: 'Nationality:',
    placeOfBirth: 'Place of Birth:',
    remarks: 'Remarks:',
    state: 'Province:',
    full_address: 'Street Address:',
    zip: 'Zip Code:',
    zipCode: 'Zip Code:'
};

export const getRevHisDetailsEndpoints = (revisionId: number): Record<string, string> => ({
    allowedEntitiesRevHistDetails: API_URLS.getAllowedEntityRevHistById(revisionId),
    deniedEntitiesRevHistDetails: API_URLS.getDeniedEntityRevHistById(revisionId),
    allowedOrganizationsRevHistDetails: API_URLS.getAllowedOrganizationRevHistById(revisionId),
    deniedOrganizationsRevHistDetails: API_URLS.getDeniedOrganizationRevHistById(revisionId),
    allowedCountryRevHistDetails: API_URLS.getAllowedCountryRevHistById(revisionId),
    deniedCountryRevHistDetails: API_URLS.getDeniedCountryRevHistById(revisionId),
    nameNoisewordsRevHistDetails: API_URLS.getNameNoisewordsRevHistById(revisionId),
    addressNoisewordsRevHistDetails: API_URLS.getAddressNoisewordsRevHistById(revisionId)
});

export const getPendingChangesEndPoints = (id: string): Record<string, string> => ({
    allowedEntitiesPendingChanges: API_URLS.getAllowedEntityPendingChanges(id),
    deniedEntitiesPendingChanges: API_URLS.getDeniedEntityPendingChanges(id),
    allowedOrganizationsPendingChanges: API_URLS.getAllowedOrganizationPendingChanges(id),
    deniedOrganizationsPendingChanges: API_URLS.getDeniedOrganizationPendingChanges(id),
    allowedCountriesPendingChanges: API_URLS.getAllowedCountriesPendingChanges(id),
    deniedCountriesPendingChanges: API_URLS.getDeniedCountriesPendingChanges(id),
    nameNoisewordsPendingChanges: API_URLS.getNameNoisewordsPendingChanges(id),
    addressNoisewordsPendingChanges: API_URLS.getAddressNoisewordsPendingChanges(id)
});

export enum IMPORT_EXPORT_STATUS {
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
    FAILED = 'FAILED'
}

export enum IMPORT_EXPORT_PROCESS_TYPE {
    IMPORT = 'IMPORT',
    EXPORT = 'EXPORT'
}

export enum FILE_UPLOAD_STATUS {
    IDLE = 'IDLE',
    INITIATED = 'INITIATED',
    UPLOADING = 'UPLOADING',
    UPLOADED = 'UPLOADED'
}

export enum IMPORTER_START_UPLOAD_SCHEMA {
    FILE_NAME = 'fileName',
    FILE_INTEGRITY_HASH = 'fileIntegrityHash'
}

export enum IMPORTER_UPLOAD_PART_SCHEMA {
    FILE_NAME = 'fileName',
    UPLOAD_ID = 'uploadId',
    PART_NUMBER = 'partNumber',
    TOTAL_PARTS = 'totalParts',
    PART_DATA = 'partData'
}

export enum IMPORTER_FILE_DELETE_SCHEMA {
    FILE_NAME = 'fileName',
    UPLOAD_ID = 'uploadId'
}

export enum SIDE_PANEL_CONTENT_TYPE {
    IN_PROGRESS = 'inProgress',
    COMPLETED = 'completed'
}

export const IMPORT_EXPORT_MESSAGES = {
    ERROR_HEADER_TITLE: 'Cannot import entries',
    ERROE_BODY_TEXT: 'You cannot import a CSV when there are pending changes to the list.',
    ERROR_OK_BUTTON_TEXT: 'Ok',
    IMPORT_INPROGRESS_MSG: 'You have a file import in progress for this list.',
    BULK_UPLOAD_MSG: (listLockedAt: string) =>
        `Editing by you – ${listLockedAt}. The file import for this list blocks further edits.`,
    LOCK_ICON: 'lock'
};

export const ASYNC_STATE = {
    CHECK_BACK_SOON_MESSAGE: 'Changes to the list are processing. Check back soon.',
    APPROVAL_FAILED_MESSAGE: (approvedBy: string, revisionId: string) =>
        `Changes approved by ${approvedBy} failed to process (Revision ID ${revisionId})`,
    ERROR_ICON: 'node-status-failure-error',
    PROCESSING_STATUS: 'processing',
    FAILED_STATUS: 'failed',
    APPROVED_STATUS: 'approved',
    CONFIG_NEEDS_REVIEW_STATUS: 'pending',
    POLLING_INTERVAL: 20000,
    CONFIG_CHANGES_SUCCESS_MESSAGE: 'Configuration change processed and applied.',
    CONFIG_CHANGES_FAIL_MESSAGE: 'Configurations change failed to process.',
    LIST_CHANGES_SUCCESS_MESSAGE: (listName: string, revisionId: string) =>
        `${listName} updated (Revision ID ${revisionId}).`,
    LIST_CHANGES_FAIL_MESSAGE: (listName: string, revisionId: string) =>
        `Changes to ${listName} failed to process(Revision ID ${revisionId}).`,
    REVIEW_CHANGES_APPROVAL_FAIL_MESSAGE: (approvedBy: string) => `Changes approved by ${approvedBy} failed to process`
};

export const PARTIAL_FAILED_MESSAGES = {
    FailedToAdd: 'Failed to Add',
    RemoveFailed: 'Remove failed',
    ModifyFailed: 'Modify failed'
};

export const MAX_SIZE = 104857600;
export const CHUNK_SIZE = 1024 * 1024 * 9; // 9 MB
export enum ConfigNameInputFamily {
    separate = 'Separate',
    combined = 'Combined'
}

export enum ConfigScoreAlgorithm {
    sumOfWeights = 'Sum of weights',
    multiOfMinimums = 'Multiplication of minimums'
}
export const ConceptOptionsEntity = [
    { value: 'firstName', label: 'First Name' },
    { value: 'middleName', label: 'Middle Name' },
    { value: 'lastName', label: 'Last Name' },
    { value: 'address', label: 'Street Address' },
    { value: 'city', label: 'City' },
    { value: 'zipCode', label: 'Zip Code' },
    { value: 'state', label: 'State' },
    { value: 'country', label: 'Country' },
    { value: 'nationality', label: 'Nationality' },
    { value: 'dateOfBirth', label: 'Date of Birth' },
    { value: 'placeOfBirth', label: 'Place of Birth' },
    { value: 'sex', label: 'sex' }
];
export const ConceptOptionsOrganization = [
    { value: 'organizationName', label: 'Organization Name' },
    { value: 'address', label: 'Street Address' },
    { value: 'city', label: 'City' },
    { value: 'zipCode', label: 'Zip Code' },
    { value: 'state', label: 'State' },
    { value: 'country', label: 'Country' }
];

export const DownloadFileStatus = 'Completed';
export const DownloadFileStatusAsDownloadFile = 'Download file;';
export const InternalListDownloadChunksSize = 500; // 500 records per chunk set from backend

export const BatchFileAllStatus = [
    {
        label: 'Processing',
        value: 'Processing'
    },
    {
        label: 'Download file',
        value: 'Completed'
    },
    {
        label: 'Failed',
        value: 'Failed'
    }
];

export const batchPollingInterval = 2000; // 2 seconds
export const showListImportBtn = false;
export const MAX_COLUMN_COUNT = 30;
/* eslint-disable quotes */
export const MAX_COLLUMN_SIZE_ERROR =
    "We couldn't process your CSV file because it has too many fields. The maximum allowed is 30.";
export const BLANK_HEADERS_ERROR = 'Header field cannot be empty.';
export const DELIMITER_ERROR = 'Please provide a custom delimiter before starting screening.';
export const QUALIFIER_ERROR = 'Please provide a custom text qualifier before starting screening.';
export const MANDATORY_ERROR = (mandatoryField: string) =>
    `At least one field must be mapped to either ${mandatoryField}, Country, or Street Address.`;
export const EMPTY_FILE_ERROR = 'File is empty';
export const DUPLICATE_ERROR = 'Each field can only be mapped to one entity. Please ensure there are no duplicates.';
export const NETWORK_ERROR = 'File failed to upload due to a network error';
export const NEEDS_REVIEW = 'needs review';
export const ALL_LISTS = 'All lists';
export const DOWNLOAD_ERROR_TITLE = 'File download error';
export const DOWNLOAD_ERROR_MSG = 'There was an error while preparing your file for download. Please try again.';
export const SCREENING_COMPLETE_MESSAGE = (fileName: string) => `Screening for "${fileName}" is complete.`;
export const SCREENING_FAILED_MESSAGE = (fileName: string) => `Screening for "${fileName}" failed.`;

export enum INTERNAL_LIST_NAME {
    'NONE',
    'INTERNAL_AE',
    'INTERNAL_DE',
    'INTERNAL_AC',
    'INTERNAL_DC',
    'INTERNAL_AO',
    'INTERNAL_DO',
    'INTERNAL_NNW_GLOBAL',
    'INTERNAL_ANW_GLOBAL'
}
export const NOISE_WORD_IDS = {
    noiseName: '5',
    noiseAddress: '6'
};
export const EDITABLE_INTERNAL_LIST_NAMES = ['Denied Countries', 'Denied Entities', 'Denied Organizations'];
export const DENIED_COUNTRY = 'DeniedCountry';
export const ALLOWED_COUNTRY = 'AllowedCountry';
export const MAX_UPLOAD_REQUEST_COUNT = 4;
export const COLLAPSED_HEIGHT = 114; // Set a default collapsed height
export const VIEW_DEFAULT_ELEMENT = 5;
// @deprecated - Use getDateTimeFormat() from utils/date.ts instead
export const DATE_FORMAT_WITH_HOUR = 'MM/DD/YYYY, hh:mm A';
// @deprecated - Use getDateTimeFormat() from utils/date.ts instead
export const DATE_FORMAT_WITHOUT_HOUR = 'MM/DD/YYYY, hh:mm';
// @deprecated - Use getDateFormat() from utils/date.ts instead
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
// @deprecated - Use getTimeFormat() from utils/date.ts instead
export const TIME_FORMAT = 'hh:mm A';
// @deprecated - Use getDateTimeFormat() from utils/date.ts instead
export const YEAR_DATETIME_FORMAT = 'YYYY/MM/DD HH:mm';
export const READ_ONLY_LIST_MESSAGE = 'This list is read only';
